<template>
  <div>
    <!-- 触发按钮 -->
    <el-button @click="openDialog" :type="buttonType" :size="buttonSize">
      {{ buttonText }}
    </el-button>

    <!-- 创建客服账号弹窗 -->
    <el-dialog
      title="生成客服账号"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="formRef" 
        label-width="100px"
      >
        <el-form-item label="客服姓名" prop="name">
          <el-input 
            v-model="form.name" 
            placeholder="请输入客服姓名"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="登录账号" prop="login_name">
          <el-input 
            v-model="form.login_name" 
            placeholder="请输入登录账号"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="登录密码" prop="pwd">
          <el-input 
            v-model="form.pwd" 
            type="password" 
            placeholder="请输入登录密码（至少6位）" 
            show-password
            clearable
          ></el-input>
        </el-form-item>
        
        <!-- <el-form-item label="手机号" prop="mobile">
          <el-input 
            v-model="form.mobile" 
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item> -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button 
          type="primary" 
          @click="handleSubmit"
          :loading="submitLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CreateConsultant',
  
  props: {
    // 按钮文本
    buttonText: {
      type: String,
      default: '生成客服账号'
    },
    // 按钮类型
    buttonType: {
      type: String,
      default: 'success'
    },
    // 按钮尺寸
    buttonSize: {
      type: String,
      default: 'small'
    },
    // 是否自动刷新列表
    autoRefresh: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      form: {
        name: '',
        login_name: '',
        pwd: '',
        mobile: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入客服姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        login_name: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]+$/, message: '只能包含字母、数字和下划线', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      manager: JSON.parse(localStorage.getItem("managerInfo"))
    };
  },

  methods: {
    // 打开弹窗
    openDialog() {
      this.dialogVisible = true;
      this.resetForm();
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.form = {
        name: '',
        login_name: '',
        pwd: '',
        mobile: ''
      };
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.createConsultant();
        } else {
          return false;
        }
      });
    },

    // 创建客服账号
    createConsultant() {
      const url = "user/user/createContact";
      
      const data = {
        nick_name: this.form.name,
        login_name: this.form.login_name,
        pwd: this.form.pwd,
      };

      this.$axios({
        url: url,
        method: "post",
        data: data
      }).then((res) => {
        this.submitLoading = false;
        
        if (res.data.code == 0) {
          this.$message({ 
            type: 'success',
            message: '客服账号创建成功',
            duration: 2000
          });
          
          this.handleClose();
          
          // 触发成功事件，父组件可以监听此事件进行列表刷新等操作
          this.$emit('success', res.data.data);
          
        } else {
          this.$message({ 
            type: 'error',
            message: res.data.message || '创建失败' 
          });
        }
      }).catch((err) => {
        this.submitLoading = false;
        this.$message({ 
          type: 'error',
          message: '创建失败，请稍后重试' 
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
// 可以在这里添加组件特定的样式
</style>
